import React from "react";
import { Link } from "react-router-dom";
import { CheckCircle2, Smartphone, KeyRound, ShieldCheck, Sparkles } from "lucide-react";

export default function BecomeHost() {
  return (
    <div className="mx-auto max-w-6xl px-6 py-16 lg:px-8">
      <div className="grid gap-12 md:grid-cols-2">
        <div>
          <span className="chip">For Zambian hosts</span>
          <h1 className="mt-6 font-display text-4xl font-bold tracking-tight text-slate-900 sm:text-5xl">Turn empty rooms into Kwacha.</h1>
          <p className="mt-6 text-lg text-slate-600 leading-relaxed">List your lodge, hotel or guest house on EasyStay and reach Zambian travellers looking for stays as short as 2 hours or as long as they need.</p>

          <div className="mt-8 space-y-3">
            {[
              { icon: Smartphone, t: "Get paid via MTN, Airtel or Zamtel" },
              { icon: KeyRound, t: "Send digital keys or share a collection address" },
              { icon: ShieldCheck, t: "Verified guests, secure payments" },
              { icon: Sparkles, t: "Free to list — pay only when you get booked" },
            ].map(({ icon: Ic, t }) => (
              <div key={t} className="flex items-center gap-3 text-slate-700">
                <div className="flex h-9 w-9 items-center justify-center rounded-xl bg-copper/10 text-copper">
                  <Ic className="h-5 w-5" />
                </div>
                <span>{t}</span>
              </div>
            ))}
          </div>

          <div className="mt-10 flex gap-3">
            <Link to="/host/new" data-testid="cta-list-property" className="btn-primary text-sm">List your property</Link>
            <Link to="/host/guidelines" data-testid="cta-host-guidelines" className="btn-outline text-sm">Read guidelines</Link>
            <Link to="/terms/host" className="btn-outline text-sm">Host agreement</Link>
          </div>
        </div>

        <div className="relative">
          <div className="rounded-[2rem] bg-forest p-8 text-white">
            <h3 className="font-display text-2xl font-bold">How hosts earn on EasyStay</h3>
            <ol className="mt-6 space-y-4 text-sm">
              {[
                "Create a listing in under 2 minutes",
                "Set your hourly and nightly rates",
                "Choose digital or physical key delivery",
                "Confirm bookings & get paid to mobile money or bank",
              ].map((s, i) => (
                <li key={s} className="flex gap-3">
                  <div className="mt-0.5 flex h-6 w-6 flex-shrink-0 items-center justify-center rounded-full bg-copper text-xs font-bold">{i + 1}</div>
                  <span className="text-white/90">{s}</span>
                </li>
              ))}
            </ol>
          </div>
          <div className="mt-6 rounded-3xl bg-white p-6 card-shadow">
            <div className="flex items-center gap-2 text-copper">
              <CheckCircle2 className="h-5 w-5" />
              <span className="text-sm font-semibold">No listing fees</span>
            </div>
            <p className="mt-2 text-sm text-slate-600">EasyStay takes a small booking fee only after a guest has paid. No upfront costs. Questions? <a href="mailto:hello@easystayzm.com" className="font-semibold text-copper hover:underline">hello@easystayzm.com</a></p>
          </div>
        </div>
      </div>
    </div>
  );
}
